import { combineReducers } from 'redux';
import SlottedSearchGridCreate from './SlottedGrid/SlottedGridCreate';
import { reducer as slottedSearchFacetReducer } from './SlottedSearchFacet';
import {
  GET_SLOTTED_SEARCH_VIEWS_START,
  GET_SLOTTED_SEARCH_VIEWS_SUCCESS,
  GET_SLOTTED_SEARCH_VIEWS_ERROR,
  GET_SLOTTED_SEARCH_SELECTED_VIEW_START,
  GET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS,
  GET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR,
  SET_SLOTTED_SEARCH_SELECTED_VIEW_START,
  SET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS,
  SET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR,
  GET_SLOTTED_SEARCH_JOB_DETAILS_START,
  GET_SLOTTED_SEARCH_JOB_DETAILS_SUCCESS,
  GET_SLOTTED_SEARCH_JOB_DETAILS_ERROR,
  SET_SLOTTED_CURRENCY
} from './SlottedSearchActions';

const initialState = {
  slottedSearchSelectedView: {
    selectedViewPk: null,
    loading: false,
    loaded: false,
    status: null,
    error: null
  },
  slottedSearchJobDetails: null,
  slottedSearchViews: {
    views: [],
    defaultViewId: null,
    loading: false,
    loaded: false,
    status: null,
    error: null
  },
  setSlottedSearchSelectedView: {
    loading: false
  },
  currency: null
};

function slottedSearchReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SLOTTED_SEARCH_VIEWS_START: {
      return {
        ...state,
        slottedSearchViews: {
          views: state.slottedSearchViews?.views,
          defaultViewId: null,
          loading: true,
          loaded: false,
          status: null,
          error: null
        }
      };
    }
    case GET_SLOTTED_SEARCH_VIEWS_SUCCESS: {
      return {
        ...state,
        slottedSearchViews: {
          views: action.views,
          defaultViewId: action.defaultViewId,
          loading: false,
          loaded: true,
          status: action.status || 200,
          error: null
        }
      };
    }
    case GET_SLOTTED_SEARCH_VIEWS_ERROR: {
      return {
        ...state,
        slottedSearchViews: {
          views: [],
          defaultViewId: null,
          loading: false,
          loaded: true,
          status: action.status || 500,
          error: action.message
        }
      };
    }
    case GET_SLOTTED_SEARCH_SELECTED_VIEW_START: {
      return {
        ...state,
        slottedSearchSelectedView: {
          selectedViewPk: state.slottedSearchSelectedView?.selectedViewPk,
          loading: true,
          loaded: false,
          status: null,
          error: null
        }
      };
    }
    case GET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS: {
      return {
        ...state,
        slottedSearchSelectedView: {
          selectedViewPk: action.selectedViewPk,
          loading: false,
          loaded: true,
          status: action.status || 200,
          error: null
        }
      };
    }
    case GET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR: {
      return {
        ...state,
        slottedSearchSelectedView: {
          selectedViewPk: null,
          loading: false,
          loaded: true,
          status: action.status,
          error: action.message
        }
      };
    }
    case SET_SLOTTED_SEARCH_SELECTED_VIEW_START: {
      return {
        ...state,
        setSlottedSearchSelectedView: {
          loading: true
        }
      };
    }
    case SET_SLOTTED_SEARCH_SELECTED_VIEW_SUCCESS: {
      return {
        ...state,
        setSlottedSearchSelectedView: {
          loading: false
        },
        slottedSearchSelectedView: {
          selectedViewPk: action.selectedViewPk,
          loading: false,
          loaded: true,
          status: action.status || 200,
          error: null
        }
      };
    }
    case SET_SLOTTED_SEARCH_SELECTED_VIEW_ERROR: {
      return {
        ...state,
        setSlottedSearchSelectedView: {
          loading: false
        }
      };
    }
    case GET_SLOTTED_SEARCH_JOB_DETAILS_START: {
      return {
        ...state
      };
    }
    case GET_SLOTTED_SEARCH_JOB_DETAILS_SUCCESS: {
      return {
        ...state,
        slottedSearchJobDetails: action.slottedSearchJobDetails
      };
    }
    case GET_SLOTTED_SEARCH_JOB_DETAILS_ERROR: {
      return {
        ...state
      };
    }
    case SET_SLOTTED_CURRENCY: {
      return {
        ...state,
        currency: action.currency
      };
    }
    default: {
      return {
        ...state
      };
    }
  }
}

export default combineReducers({
  slottedSearchReducer,
  slottedSearchGridReducer: SlottedSearchGridCreate,
  slottedSearchFacetReducer
});
